import {Link, useParams} from 'react-router-dom';
import React/*, {useState}*/ from 'react';

import {useracc, postApi, setTitle, consoleLog} from '../../utils/functions';
import {UserContext, TestService} from '../../utils/usercontext';
import EventEmitter from '../../utils/emmiter';
//import CopyBox from '../components/bbcode/copybox';
//import VideoPlayer from '../components/video/video';
//import Genres from './components/genres/genres';
//import AudioBox from './components/audio/audiobox';
//import moment from 'moment';
//import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
//import '../components/fontawesome/fontawesome';


//import { Swiper, SwiperSlide } from 'swiper/react';
//import { Autoplay, Pagination, Navigation } from "swiper";
//import 'swiper/css';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
//import Button from 'react-bootstrap/Button';

//import './css/stream.css';
//import './css/header.css';

class PortalServiceOverview extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);
    this.state = {

			service: {
				status: false,
				id: this.props.service,
				name: '',
				test: false
			},

			admins: [],
			members: [],
			

      //servicekey: '',
			overview: {},
			
      
		};
    
  };

  async componentDidMount() {
		//document.title = "";

		//---- This i believe you do actaully to update on page changes!
		const value = this.context;
		const getUser = await useracc();
		value.setUser( getUser );
		const y = await value.setWorker( this.props.service );
		let server = value.worker[this.props.service] || y[this.props.service];
		//value.setTheme( '/themes/default-dark.css' );
		

		let params = new URLSearchParams();
		params.append('service', this.state.service.id);
		const x = await postApi(`${server}/v3/service/overview`, params);

		EventEmitter.emit('/client', y);
		
		consoleLog(x.data);
		if( x.status === 200 ) {
			let service = this.state.service;
			if( service.name !== x.data.servicename || service.status === false ) {
				service.name = x.data.servicename;
				service.status = true;
				this.setState({service});
				setTitle(x.data.servicename);
			}
			this.setState({overview: x.data.overview, admins: x.data.admins, members: x.data.members});
		}
   
		
	}

	componentWillUnmount() {
    
	}

  
	render() {
		const user = this.context;

		const online_admins = this.state.admins.map((e,i) => {
			return (
				<li key={i}>
					<Link to={`/profile/${e.username}`}>
						<div className="d-flex align-items-center">
							<div className="me-2 d-flex align-items-center">
								<span className={`avatar avatar-sm avatar-rounded ${'online'}`}>
									<img src={`https://cloud.ultrastream.io${e.avatar}`} alt="" className="rounded-circle" />
								</span>
								</div>
								<div className="flex-fill">
									<span>{e.title?e.title:e.username}</span>
								</div>
								<div>
									<span className="fs-10 fw-semibold text-muted">10 mins</span>
								</div>
						</div>
					</Link>
				</li>
			)
		});
		const online_members = this.state.members.map((e,i) => {
			return (
				<li key={i}>
					<Link to={`/profile/${e.username}`}>
						<div className="d-flex align-items-center">
							<div className="me-2 d-flex align-items-center">
								<span className={`avatar avatar-sm avatar-rounded ${'online'}`}>
									<img src={`https://cloud.ultrastream.io${e.avatar}`} alt="" className="rounded-circle" />
								</span>
								</div>
								<div className="flex-fill">
									<span>{e.title?e.title:e.username}</span>
								</div>
								<div>
									<span className="fs-10 fw-semibold text-muted">10 mins</span>
								</div>
						</div>
					</Link>
				</li>
			)
		});
		

		return (
			<>
				<div className="d-sm-flex d-block align-items-center justify-content-between page-header-breadcrumb">
					<h4 className="fw-medium mb-0">Overview</h4>
					<div className="ms-sm-1 ms-0">
						<nav>
							<ol className="breadcrumb mb-0">
								<li className="breadcrumb-item"><Link to={`/${this.state.service.id}`}>{this.state.service.name}</Link></li>
								<li className="breadcrumb-item active" aria-current="page">Dashboard</li>
							</ol>
						</nav>
					</div>
				</div>
				{this.state.service.status === true &&
				
					<div className="main-content app-content">
						<div className="container-fluid">
              <Row>
                <Col lg={9}>

									<div className="card custom-card">
                    <div className="d-flex p-3 border-bottom-0">
                      <div className="">
                        <svg className="me-4  bg-success-transparent  alt-notify" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="#75cfa5" d="m20.34 9.32-13.99-7a3 3 0 0 0-4.08 3.9L4.41 11l.26.59a1.06 1.06 0 0 1 0 .82l-.26.59-2.14 4.78a2.954 2.954 0 0 0 .67 3.38A2.966 2.966 0 0 0 5 22a3.141 3.141 0 0 0 1.35-.32l13.99-7a2.993 2.993 0 0 0 0-5.36Z"></path><path fill="#198754" d="M14.46 12a.997.997 0 0 1-1 1H4.41l.26-.59a1.06 1.06 0 0 0 0-.82L4.41 11h9.05a.997.997 0 0 1 1 1Z"></path></svg>
                      </div>
                      <div className="mt-0 text-start">
                        <span className="fs-14 fw-semibold">{this.state.service.name}</span>
                        <p className="fs-13 text-muted mb-0">An overview and outlook of your {this.state.overview.title}.</p>
                      </div>
                      
                    </div>
										<TestService service={this.state.service.id} worker={user.worker[this.state.service.id]} />
                  </div>
									

									

									<div className="card custom-card custom-frame">
                    <div className="card-header justify-content-between">
                      <div className="card-title">
                        {this.state.overview.title}
                      </div>
                    </div>
                    <div className="card-body">
											<Row>
												{this.state.overview.live === true ?
													<></>
												:
													<>
														<Col xs={2}>
															<img src={`https://cloud.ultrastream.io/images/${this.state.overview.avatar}`} width="100%" alt="Station Avatar" />
														</Col>
														<Col>
															Status: Idle<br />
															Members: {this.state.overview.membersMax}<br />
															Ower: <Link to={`/${this.state.overview.owner.username}`}>{this.state.overview.owner.title}</Link><br />
															Admins: {this.state.overview.adminsMax}
															{/*(() => {
																const y = this.state.overview.admins.map((g,k) => {
																	return(
																		<React.Fragment key={k}>&nbsp;- {g.title}</React.Fragment>
																	)
																});
																	return y;
																})()*/}
															<br />
														</Col>
													</>
												}
											</Row>
											
										</div>
									</div>

								</Col>
								<Col>
								
									<div className="team-groups">
										<div className="card custom-card">
											<div className="card-header d-flex align-items-center justify-content-between">
												<h6 className="fw-semibold mb-0">Radio Team</h6>
											</div>
											<div className="card-body p-0">
												<div className="teams-nav" id="teams-nav" data-simplebar="init">
													<div className="simplebar-wrapper" style={{margin: 0}}>
														<div className="simplebar-height-auto-observer-wrapper">
																<div className="simplebar-height-auto-observer"></div>
														</div>
														
																<div className="simplebar-content-wrapper" tabIndex="0" role="region" aria-label="scrollable content" >
																	<div className="simplebar-content" style={{padding: 0}}>
																		<ul className="list-unstyled mb-0 mt-2">
																			<li className="pb-0">
																				<div className="d-flex justify-content-between align-items-center">
																					<div className="fs-10 fw-semibold mb-2 text-muted">OWNER / ADMINS</div>
																				</div>
																			</li>
																			{online_admins}
																			<li className="pb-0">
																				<div className="d-flex justify-content-between align-items-center">
																					<div className="fs-10 fw-semibold mb-2 text-muted">DJ TEAM</div>
																				</div>
																			</li>
																			{online_members}
																		</ul>
																	</div>
																</div>
															
														{/*<div className="simplebar-placeholder" style={{width: 'auto', height: 890}}></div>*/}
													</div>
													<div className="simplebar-track simplebar-horizontal" style={{visibility: 'hidden'}}>
														<div className="simplebar-scrollbar" style={{width: 0, display: 'none'}}></div>
													</div>
													<div className="simplebar-track simplebar-vertical" style={{visibility: 'hidden'}}>
														<div className="simplebar-scrollbar" style={{height: 728, transform: 'translate3d(0px, 0px, 0px)', display: 'block'}}></div>
													</div>
												</div>
											</div>
										</div>
									</div>

								</Col>
              </Row>
            </div>
					</div>
				}
			</>
		);
	}
}

const Stream = props => {
  const { service } = useParams();
  return <PortalServiceOverview service={service} {...props} />
}
export default Stream;